<div [ngSwitch]="commonModalService.showModalTemplateName"
     vTp="common-modal"
     [hidden]="!commonModalService.showModal"
>
<div class="m-modal-router is-visible"
     [ngClass]="PAGE_COVERING_CLASS_NAME"
>
  <div class="a-modal-router-content"
       [ngClass]="PAGE_COVERING_CLASS_NAME"
  >
    <div class="m-modal-template">
      <a *ngIf="commonModalService.showCloseBtn"
           (click)="closeModal()"
           class="close-btn fi flaticon-close"
      ></a>
      <v-modal-information-and-action *ngSwitchCase="CommonModalTemplatesEnum.INFO_ADN_ACTION"></v-modal-information-and-action>
      <v-modal-statement *ngSwitchCase="CommonModalTemplatesEnum.STATEMENT"></v-modal-statement>
      <v-modal-asm-expire *ngSwitchCase="CommonModalTemplatesEnum.ASM_EXPIRE"></v-modal-asm-expire>
      <v-modal-confirm *ngSwitchCase="CommonModalTemplatesEnum.INFO_AND_CONFIRM"></v-modal-confirm>
      <v-modal-cancel-order *ngSwitchCase="CommonModalTemplatesEnum.CANCEL_ORDER"></v-modal-cancel-order>
      <v-modal-cancel-subscription *ngSwitchCase="CommonModalTemplatesEnum.CANCEL_SUBSCRIPTION"></v-modal-cancel-subscription>
    </div>

  </div>
</div>

</div>
